(function() {
    'use strict';
    
a3_cabin_reports.factory('SearchFlightsFactory', SearchFlightsFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name SearchFlightsFactory
    * @description 
    * Get selected flight info
    * @ngInject
    */ 
function SearchFlightsFactory($http, $q, apiUrl,$timeout) {

    var service = {
        getFlights: getFlights,
        getFlightInfo: getFlightInfo
    };

    function getFlights(criteria, callback) {
        //test UI:
        //return getFlightsDummy(criteria)

        var flightDate =  criteria.flightDatePicker.value.toString('yyyy-MM-dd');
        var uri = encodeURI(apiUrl + '/SearchFlights/GetFlights?flightDate=' + flightDate + 
                                                            '&flightNo=' + criteria.flightNo + 
                                                            '&departure=' + criteria.departure +
                                                            '&arrival=' + criteria.arrival);

         return $http.get(uri, { 'Content-Type': 'application/json' })
         .catch(callback); 

        
    }           

    function getFlightInfo(flightId, flightDate, flightNo, departure, callback){
        var flightDateStr =  flightDate.toString('yyyy-MM-dd');

        // $http({
        //     url: apiUrl + '/SearchFlights/GetFlightInfo', 
        //     method: "GET",
        //     contentType: "application/json",
        //     params: {flightId: flightId, flightDate: flightDateStr, flightNo: flightNo, departure: departure}
        //  });

         var uri = encodeURI(apiUrl + '/SearchFlights/GetFlightInfo?flightId=' + flightId + 
                                                    '&flightDate=' + flightDateStr + 
                                                    '&flightNo=' + flightNo + 
                                                    '&departure=' + departure);

        return $http.get(uri, { 'Content-Type': 'application/json' })
        .catch(callback); 

    }


    function getFlightsDummy(criteria) {
        // Create a deferred object to handle the promise
        var deferred = $q.defer();
        // Simulate an asynchronous operation (e.g., API call) with a delay
        $timeout(function(){
            var flightDate = criteria.flightDatePicker.value.toString('yyyy-MM-dd');

            // Simulate getting flight data asynchronously
            var testSuccessResults = {
                data: getDummyFlightResults(),
                success: true,
                errorMessage: ""
            };

            // Resolve the promise with the retrieved data
            deferred.resolve(testSuccessResults);
        },2000);

       

        // Return the promise
        return deferred.promise;
    }

    function getDummyFlightResults(){
        return {
            "FlightsFound": 
            [{
                "Id": 1,
                "FlightNo": "A3123",
                "FlightDate": "2023-10-20T00:00:00",
                "Registration":"AAA-OK1",
                "STD": "2023-10-20T08:00:00",
                "STA": "2023-10-20T12:00:00",
                "Departure": "ATH",
                "Arrival": "SKG"
            },
            {
                "Id": 2,
                "FlightNo": "A3789",
                "FlightDate": "2023-10-21T00:00:00",
                "Registration":"AAA-OK2",
                "STD": "2023-10-21T15:30:00",
                "STA": "2023-10-21T19:30:00",
                "Departure": "SKG",
                "Arrival": "ATH"
            },
            {
                "Id": 3,
                "FlightNo": "OA456",
                "FlightDate": "2023-10-22T00:00:00",
                "Registration":"CCC-OK3",
                "STD": "2023-10-22T10:15:00",
                "STA": "2023-10-22T14:15:00",
                "Departure": "ATH",
                "Arrival": "SKG"
            }]
        };
    }


    return service;
}
})();